/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EPanelDrawerState {
  Closed,
  HalfOpen,
  Open
}
